import { useQuery } from 'react-query';
import { getUser } from '../api/user';
import { QueryKeys } from '../constants';

export function useGetUser(id: string | undefined) {
    const { data: userData, isLoading } = useQuery([QueryKeys.getUser, id], () => getUser({ id: id as string }), {
        retry: false,
        staleTime: Infinity,
        cacheTime: 100,
        enabled: !!id,
    });
    return { userData, isLoading };
}
